export default __webpack_public_path__ + "static/media/Food.168c3cf8.svg";